module.exports = "<div class=\"mbol-popup-wrapper\">\n  <lfwms-result-data-table [searchService]=\"lookupSearchService\" [popupMode]=\"true\">\n  </lfwms-result-data-table>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/mbol-error-log-popup/mbol-error-log-popup.component.html
// module id = ../../../../../src/app/shared/lookup/mbol-error-log-popup/mbol-error-log-popup.component.html
// module chunks = main